import { render, staticRenderFns } from "./FirstComponent.vue?vue&type=template&id=efe00a6a&scoped=true&"
import script from "./FirstComponent.vue?vue&type=script&lang=js&"
export * from "./FirstComponent.vue?vue&type=script&lang=js&"
import style0 from "./FirstComponent.vue?vue&type=style&index=0&id=efe00a6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe00a6a",
  null
  
)

export default component.exports